export default __webpack_public_path__ + "static/media/ce-1.059f5930.png";